<template>
  <div>
    <div class="monitor container is-fluid">
      <div class="columns">
        <div class="column is-8">
          <h4 class="is-size-4-desktop">Usuarios</h4>
          <h4 v-if="bodega" class="is-size-6-desktop">
            Sucursal: {{ bodega.sucursal.nombre }} - {{ bodega.nombre }}
          </h4>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-table
            :narrowed="true"
            :bordered="true"
            :data="usuarios"
            :paginated="true"
            :per-page="tamanoPagina"
            :current-page.sync="paginaActual"
            :pagination-simple="false"
            pagination-position="bottom"
            default-sort="user.id"
            aria-next-label="Siguiente página"
            aria-previous-label="Página anterior"
            aria-page-label="Página"
            aria-current-label="Página actual"
          >
            <b-table-column
              v-slot="props"
              class="has-text-centered"
              field="id"
              label="Código"
              width="15%"
            >
              <span>
                {{ props.row.id }}
              </span>
            </b-table-column>
            <b-table-column
              v-slot="props"
              class="has-text-centered"
              field="nombre"
              label="Nombre Usuario"
            >
              <span>
                {{ props.row.nombre }}
              </span>
            </b-table-column>
            <b-table-column
              v-slot="props"
              field="nombre"
              label="Está activo?"
              :centered="true"
              width="140"
            >
              <b-icon :icon="props.row.estaDisponible ? 'check' : 'times'" />
            </b-table-column>
            <b-table-column v-slot="props" label="Acciones" width="8%">
              <b-button
                type="is-info"
                size="is-small"
                :disabled="cargando"
                @click="modificarRegistro(props.row.id)"
              >
                <b-icon
                  :icon="icono"
                  :custom-class="cargando ? 'fa-spin' : ''"
                />
              </b-button>
              &nbsp;
              <b-button
                type="is-danger"
                size="is-small"
                :disabled="cargando"
                @click="confirmarEliminarRegistro(props.row.id)"
              >
                <b-icon icon="trash-alt" />
              </b-button>
            </b-table-column>
            <template slot="empty">
              <div class="content has-text-grey has-text-centered">
                <p>No hay registros.</p>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-button
            type="is-info"
            icon-left="plus"
            :disabled="!puedeAgregar"
            @click="agregarRegistro"
          >
            Agregar
          </b-button>
        </div>
      </div>
    </div>
    <b-modal
      :active.sync="estaModalAbierto"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      @close="cerrarModalHandle"
    >
      <usuario-form
        :titulo="tituloForm"
        :modificacion="modificacion"
        :bodega-id="bodega.id"
        :roles="roles"
        :objeto="objeto"
        @close="cerrarModalHandle"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import UsuarioForm from '@/components/mantenedor/usuarios/UsuarioForm.vue'
import { usuarioService } from '@/services'

export default {
  name: 'Usuarios',
  components: {
    UsuarioForm
  },
  data() {
    return {
      usuarios: [],
      roles: [],
      estaModalAbierto: false,
      paginaActual: 1,
      tamanoPagina: 10,
      tituloForm: null,
      objeto: null,
      modificacion: false,
      cargando: false
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    puedeAgregar() {
      return !this.cargando
    },
    icono() {
      return this.cargando ? 'sync-alt' : 'pencil-alt'
    }
  },
  mounted() {
    this.getUsuarios()
    this.getRoles()
  },
  beforeDestroy() {},
  methods: {
    agregarRegistro() {
      this.tituloForm = 'Agregar Usuario'
      this.estaModalAbierto = true
    },
    async modificarRegistro(id) {
      this.tituloForm = 'Modificar Usuario'
      this.cargando = true
      const rs = await usuarioService.getUsuarioBodega(id, this.bodega.id)
      this.objeto = rs.data
      this.objeto.roles = this.objeto.roles.map((x) => {
        return { id: x.id }
      })
      this.modificacion = true
      this.estaModalAbierto = true
      this.cargando = false
    },
    confirmarEliminarRegistro(id) {
      const objeto = this.usuarios.filter((item) => item.id === id)[0]
      this.$buefy.dialog.confirm({
        title: 'Quitar usuario',
        message: `¿Est&aacute; seguro de <b>quitar</b> el usuario <b>${objeto.id}</b>?`,
        confirmText: 'Eliminar',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.eliminarRegistro(id)
      })
    },
    eliminarRegistro(id) {
      usuarioService
        .deleteUsuario(id, this.bodega.id)
        .then(() => {
          this.notificarAccionCompletada('Se eliminó usuario correctamente')
          this.getUsuarios()
        })
        .catch((error) => this.procesarError(error))
    },
    cerrarModalHandle(payload = false) {
      this.estaModalAbierto = false
      this.tituloForm = ''
      this.objeto = null
      this.modificacion = false
      if (payload) {
        this.getUsuarios()
      }
    },
    getUsuarios() {
      const self = this
      return usuarioService
        .getUsuarios(this.bodega.id)
        .then((response) => (self.usuarios = response.data))
        .catch((error) => this.procesarError(error))
    },
    getRoles() {
      const self = this
      return usuarioService
        .getRoles()
        .then((response) => (self.roles = response.data))
        .catch((error) => this.procesarError(error))
    }
  }
}
</script>
